const config = {
  rowSelection: false,
  search: false,
  scroll: {
    y: 'calc(100vh - 510px)',
  },
  columns: [
    {
      title: '订单编号',
      dataIndex: 'orderNo',
      render: 'orderIdRender',
      width: 180,
      fixed: 'left',
    },
    {
      title: '对应商机',
      dataIndex: 'trackId',
      width: 200,
      render: (text: string) => text || '-',
    },
    {
      title: '需求标签',
      dataIndex: 'bizTagDisplay',
      width: 120,
      render: 'demandTagRender',
    },
    {
      title: '销售商品',
      dataIndex: 'quoteGoodsName',
      width: 180,
      ellipsis: true,
    },
    {
      title: '订单金额',
      dataIndex: 'totalPrice',
      width: 150,
      render: 'orderAmountRender',
    },
    {
      title: '服务地址',
      dataIndex: 'serviceAddress',
      width: 240,
      ellipsis: true,
    },
    {
      title: '订单状态',
      dataIndex: 'statusDisplay',
      width: 120,
      render: 'orderStatusRender',
    },
    {
      title: '创建人',
      dataIndex: 'createdByName',
      width: 120,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      width: 120,
      itemType: 'dateTime',
    },
  ],
  footer: false,
}

export default config
